import thunk from 'redux-thunk';
import {
  createStore, applyMiddleware, compose, combineReducers,
} from 'redux';

import usersReducer from './users/reducers';
import rolesReducer from './roles/reducers';
import dashboardDatasReducer from './dashboardDatas/reducers';
import rentersReducer from './renters/reducers';
import bikesReducers from './bikes/reducers';
import rentsReducers from './rents/reducers';
import sitesReducers from './sites/reducers';
import standsReducers from './stands/reducers';
import infosReducers from './infos/reducers';
import vouchersReducers from './vouchers/reducers';
import booksReducers from './books/reducers';
import lltsReducers from './longLocationDurations/reducers';
import booksLldReducers from './booksLld/reducers';
import sitesLldReducers from './sitesLld/reducers';
import rentsLldReducers from './rentsLld/reducers';
import lldWaitingUsersReducers from './lldWaitingUsers/reducers';
import feedbacksReducers from './feedbacks/reducers';
import uiReducers from './ui/reducers';

const reducers = combineReducers({
  users: usersReducer,
  roles: rolesReducer,
  dashboardDatas: dashboardDatasReducer,
  renters: rentersReducer,
  bikes: bikesReducers,
  sites: sitesReducers,
  rents: rentsReducers,
  stands: standsReducers,
  infos: infosReducers,
  vouchers: vouchersReducers,
  books: booksReducers,
  llts: lltsReducers,
  booksLld: booksLldReducers,
  sitesLld: sitesLldReducers,
  rentsLld: rentsLldReducers,
  lldWaitingUsers: lldWaitingUsersReducers,
  feedbacks: feedbacksReducers,
  ui: uiReducers,
});

// eslint-disable-next-line no-underscore-dangle
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(reducers, composeEnhancers(applyMiddleware(thunk)));

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js